import { RootState } from "store";

export const getOfferState = (state: RootState) => state.offers;
export const getOffersList = (state: RootState) => state.offers.offers;
export const getOffersErrors = (state: RootState) => state.offers.error;
